var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRoom = function SvgRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.94,
    height: 21.38,
    viewBox: "0 0 14.94 21.38"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-0.038 -0.038)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    y1: 9.16,
    transform: "translate(6.479 11.73)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    x2: 9,
    transform: "translate(5.979 20.918)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_120",
    "data-name": "Line 120",
    x2: 4.807,
    transform: "translate(6.171 17.918)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x1: 6.541,
    y1: 6.541,
    transform: "translate(0.392 6.19)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    y1: 6.541,
    x2: 6.541,
    transform: "translate(6.171 6.19)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x2: 6.541,
    y2: 6.541,
    transform: "translate(6.206 0.392)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    x1: 6.541,
    y2: 6.541,
    transform: "translate(0.392 0.392)",
    fill: "none",
    stroke: "#cfded7",
    strokeWidth: 1
  }))));
};

export { SvgRoom as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNC45NCIgaGVpZ2h0PSIyMS4zOCIgdmlld0JveD0iMCAwIDE0Ljk0IDIxLjM4Ij4KICA8ZyBpZD0iR3JvdXBfMzUiIGRhdGEtbmFtZT0iR3JvdXAgMzUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjAzOCAtMC4wMzgpIj4KICAgIDxsaW5lIGlkPSJMaW5lXzcwIiBkYXRhLW5hbWU9IkxpbmUgNzAiIHkxPSI5LjE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2LjQ3OSAxMS43MykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2NmZGVkNyIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8bGluZSBpZD0iTGluZV83MSIgZGF0YS1uYW1lPSJMaW5lIDcxIiB4Mj0iOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS45NzkgMjAuOTE4KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2ZkZWQ3IiBzdHJva2Utd2lkdGg9IjEiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzEyMCIgZGF0YS1uYW1lPSJMaW5lIDEyMCIgeDI9IjQuODA3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2LjE3MSAxNy45MTgpIiBmaWxsPSJub25lIiBzdHJva2U9IiNjZmRlZDciIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNzIiIGRhdGEtbmFtZT0iTGluZSA3MiIgeDE9IjYuNTQxIiB5MT0iNi41NDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuMzkyIDYuMTkpIiBmaWxsPSJub25lIiBzdHJva2U9IiNjZmRlZDciIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNzMiIGRhdGEtbmFtZT0iTGluZSA3MyIgeTE9IjYuNTQxIiB4Mj0iNi41NDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYuMTcxIDYuMTkpIiBmaWxsPSJub25lIiBzdHJva2U9IiNjZmRlZDciIHN0cm9rZS13aWR0aD0iMSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfNzQiIGRhdGEtbmFtZT0iTGluZSA3NCIgeDI9IjYuNTQxIiB5Mj0iNi41NDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYuMjA2IDAuMzkyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjY2ZkZWQ3IiBzdHJva2Utd2lkdGg9IjEiLz4KICAgIDxsaW5lIGlkPSJMaW5lXzc1IiBkYXRhLW5hbWU9IkxpbmUgNzUiIHgxPSI2LjU0MSIgeTI9IjYuNTQxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjM5MiAwLjM5MikiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2NmZGVkNyIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgPC9nPgo8L3N2Zz4K";